var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-header"},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" "),_c('br',{staticClass:"hideOnDesktop"}),_c('span',{staticClass:"emphasize"},[_vm._v(_vm._s(_vm.$t(_vm.emphasize)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }